import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { bloodPressureConsumablesDataSource } from 'infrastructure/data-sources/blood-pressure-consumables';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IBloodPressureConsumablesItem } from 'infrastructure/data-sources/blood-pressure-consumables';

type Options = IBaseSelectBoxOption<
  IBloodPressureConsumablesItem['id'],
  IBloodPressureConsumablesItem
>[];

interface IBloodPressureConsumablesSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const BloodPressureConsumablesSelectBox: React.FC<
  IBloodPressureConsumablesSelectBoxProps
> = (props) => {
  const dataSource = useMemo(() => bloodPressureConsumablesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default BloodPressureConsumablesSelectBox;
